<template>
  <div class="invoice-address">
    <div class="table-info">
      <div class="info-head">
        <span class="title">发票地址 </span>
        <button
          v-if="!whether_address"
          class="addaddress"
          @click="addAddress()"
        >
          新增发票地址
        </button>
      </div>
      <div class="is_address_status">
          <span>是否同收货地址</span>
          <el-switch
            v-model="whether_address"
            @change="changeAddressSatus()"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      <div class="address-info-box" v-if="!whether_address">
        <div
          class="info-middle"
          v-for="(item, index) in addressData.length > 0
            ? addressData.slice(0, 1)
            : infoData.slice(0, 1)"
          :key="index"
          @click="getAddress(item.id)"
        >
          <div>
            <span :class="invoiceId == item.id ? 'active' : ''">{{
              item.username
            }}</span>
            <p>
              {{ item.username }} {{ item.province_name }} {{ item.city_name }}
              {{ item.district_name }} {{ item.address }} {{ item.phone }}
            </p>
          </div>
        </div>
        <div class="info-bottom">
          <span @click="showdialog()" v-if="infoData.length > 1">更多地址</span>
        </div>
      </div>
      <div class="div"></div>
    </div>
    <div class="dialog" v-if="dialog">
      <div v-for="(item, index) in infoData" :key="index" class="listone">
        <div @click="btnClick(item)">
          <span
            :class="invoiceId == item.id ? 'active' : ''"
            @click="pushData(item)"
            >{{ item.username }}</span
          >
          <p @click="pushData(item)">
            {{ item.username }} {{ item.phone }} {{ item.province_name }}
            {{ item.city_name }} {{ item.district_name }} {{ item.address }}
          </p>
        </div>
      </div>
    </div>
    <invoiceAddress
      class="dialog-box"
      @updateData="getList"
      v-if="flag"
      :flag="this.flag"
      @flag="disappear"
      :id="this.id"
      :changeState="this.changeState"
    ></invoiceAddress>
  </div>
</template>

<script>
import invoiceAddress from "../../personalCenter/InvoiceControl/components/children/invoiceAdd";
export default {
  props: ["shippingAddress"],
  data() {
    return {
      infoData: [],
      invoiceId: "",
      dialog: false,
      addressData: [],
      flag: false,
      changeState: false,
      whether_address: true,
      id: "",
    };
  },
  components: {
    invoiceAddress,
  },
  methods: {
    btnClick(item) {
      this.$emit("itemClick", item);
    },
    changeAddressSatus() {
      this.$store.state.whether_addressStatus = this.whether_address;
    },
    getList() {
      this.$api.invoice.invoiceAddressList({}).then((res) => {
        this.infoData = res.data;
        if (res.data.length > 0) {
          this.invoiceId = res.data[0].id;
          this.$store.state.invoiceId = res.data[0].id;
        } else {
          (this.invoiceId = ""), (this.$store.state.invoiceId = "");
        }
      });
    },
    disappear(params) {
      this.flag = params;
    },
    pushData(item) {
      this.addressData = [];
      this.addressData.unshift(item);
      this.invoiceId = this.addressData[0].id;
      this.dialog = !this.dialog;
    },
    getAddress(id) {
      this.invoiceId = id;
      this.$store.state.invoiceId = this.invoiceId;
    },
    addAddress() {
      this.flag = true;
      this.changeState = false;
    },
    showdialog() {
      this.dialog = !this.dialog;
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style  lang="less" scoped>
.dialog-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.dialog {
  .listone {
    div {
      display: flex;
      align-items: center;
      padding-top: 21px;
      font-size: 14px;
      color: #333333;
      span {
        width: 180px;
        height: 38px;
        border: 2px solid #dddddd;
        text-align: center;
        line-height: 38px;
        margin-left: 58px;
        &.active {
          border: 2px solid #ffbb00;
        }
      }
      p {
        margin-left: 14px;
      }
    }
  }
} 
.is_address_status{
  display: flex;
  align-items: center;
  margin:0px 60px;
  margin-top: 20px;
  span{
    margin-right:10px;
    font-size: 16px;
  }
}
.table-info {
  width: 100%;
  min-height: 49px;
  .info-head {
    .title {
      height: 24px;
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      margin-left: 34px;
      a {
        margin-left: 14px;
        font-size: 14px;
        cursor: pointer;
        color: #ffbb00;
      }
    }
    .addaddress {
      height: 40px;
      width: 120px;
      font-size: 15px;
      color: #fff;
      cursor: pointer;
      border: 0px;
      margin: 15px;
      background: #003871;
    }
  }
  .info-middle {
    height: 75px;
    div {
      display: flex;
      padding-top: 21px;
      font-size: 14px;
      color: #333333;
      span {
        width: 180px;
        height: 38px;
        border: 2px solid #dddddd;
        text-align: center;
        line-height: 38px;
        margin-left: 58px;
        &.active {
          border: 2px solid #ffbb00;
        }
      }
      p {
        margin-left: 14px;
        line-height: 38px;
      }
    }
    span {
      width: 180px;
      height: 38px;
      border: 2px solid #dddddd;
      text-align: center;
      line-height: 38px;
      margin-left: 58px;
    }
    p {
      margin-left: 14px;
    }
  }
  .info-bottom {
    cursor: pointer;
    span {
      font-size: 14px;
      color: #999999;
      margin-left: 60px;
    }
  }
}
</style>